import { SVGProps } from 'react';

const SvgArrowRight = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 4 10" {...props}>
        <path d="m0 10 4-5-4-5v10Z" />
    </svg>
);
export default SvgArrowRight;
